import { startMainQuestions } from "../api/ApiAppForm";

interface IUseAFApplication {
    createApp: (
        quoteGroupId: string,
        applicationId: number,
        providerId: number
    ) => any;
}

function createApp(
    quoteGroupId,
    applicationId,
    providerId
) {
    const params = {
        quoteGroupId: quoteGroupId,
        applicationId: applicationId,
        providerId: providerId
    };
    return new Promise((resolve, reject) => {
        startMainQuestions(params)
            .then((res) => {
                const applicants = res?.applicants;
                if (!applicants || !applicants?.length) {
                    reject("Error creating applicants");
                    return;
                }
                resolve(res);
            })
            .catch(() => {
                reject("Error creating applicaiton");
                return;
            });
    });
}

const useAFApplication = (): IUseAFApplication => {
    return {
        createApp
    };
};

export default useAFApplication;
